import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  Input,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  HostBinding,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabComponent } from '../tab/tab.component';

@Component({
  selector: 'hyperkit-tab-bar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabBarComponent implements AfterContentInit {
  @Input() variant: 'primary' | 'secondary' | 'tertiary' = 'primary';
  @Input() mode: 'underline' | 'text' = 'underline';
  @Input() controlled = false; // ✅ Added controlled mode

  public selectedTab: TabComponent | null = null;

  @HostBinding('style.width') width = '100%';

  @ContentChildren(TabComponent)
  tabs: QueryList<TabComponent> = new QueryList<TabComponent>();

  constructor(private cdr: ChangeDetectorRef) {}

  ngAfterContentInit(): void {
    this.tabs.forEach((tab) => {
      tab.variant = this.variant;
      tab.mode = this.mode;

      if (!this.controlled) {
        tab.tabClick.subscribe(() => this.onTabClick(tab));
      }
    });

    if (!this.controlled) {
      this.initializeSelectedTab();
    }

    this.cdr.markForCheck();
  }

  onTabClick(tab: TabComponent): void {
    if (this.controlled) return; // Don't mutate selection in controlled mode

    this.tabs.forEach((t) => t.deselect());
    tab.selected = true;
    this.selectedTab = tab;
    this.cdr.markForCheck();
  }

  initializeSelectedTab(): void {
    const selectedTabs = this.tabs.filter((tab) => tab.selected);
    if (selectedTabs.length > 0) {
      this.selectedTab = selectedTabs[0];
    } else {
      this.selectedTab = this.tabs.first ?? null;
      if (this.selectedTab) {
        this.selectedTab.selected = true;
      }
    }
    this.cdr.markForCheck();
  }
}
